import React from 'react';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  BCC_USER_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  DISCOVERY_USER_ROUTE,
  JFT_USER_ROUTE,
  MGMENT_USER_ROUTE,
  USER_MANAGEMENT_MODULE_ROUTE,
} from '../../routes/routes';
import useScopes from '../../hooks/useScopes';
import { useSelector } from 'react-redux';
const linkStyle = {
  height: 64,
  paddingLeft: 16,
  paddingRight: 16,
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 4,
};

const useStyles = makeStyles((theme) => ({
  overAll: { paddingLeft: 5, paddingRight: 5 }, // 438
  linkStyle: {
    ...linkStyle,
  },
  linkStyleActive: {
    ...linkStyle,
    backgroundColor: theme.palette.buzzActiveLinkBackground,
  },
  textStyle: {
    textDecoration: 'none',
  },
}));

const isActiveRoute = (routeName, pathName) => {
  if (
    pathName === USER_MANAGEMENT_MODULE_ROUTE.slice(0, -1) &&
    routeName === MGMENT_USER_ROUTE
  ) {
    return true;
  } else if (pathName !== USER_MANAGEMENT_MODULE_ROUTE.slice(0, -1)) {
    return pathName.includes(routeName);
  }
};

const SideNavBarUser = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const theme = useTheme();
  const { access } = useScopes();

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  const paths = [
    {
      name: 'Management App',
      link: MGMENT_USER_ROUTE,
      scope: 'approval:management:readWrite',
    },
    {
      name: 'Discovery App',
      link: DISCOVERY_USER_ROUTE,
      scope: 'approval:discovery:readWrite',
    },
    {
      name: 'JFT',
      link: JFT_USER_ROUTE,
      scope: '',
    },
    {
      name: 'BCC User',
      link: BCC_USER_ROUTE,
      scope: '',
    },
    {
      name: 'Change Password',
      link: CHANGE_PASSWORD_ROUTE,
      scope: '',
    },
  ];

  return (
    <Box
      flex={2}
      mr={3}
      border={1}
      borderColor={theme.palette.buzzBorder}
      borderRadius={4}
      className={classes.overAll}>
      {/* {paths.map((path) => {
        const isActive = isActiveRoute(path.link, pathname);
        return (
          <Link
            key={path.name}
            to={path.link}
            color="inherit"
            className={classes.textStyle}>
            <Box
              className={isActive ? classes.linkStyleActive : classes.linkStyle}
              display="flex"
              alignItems="center">
              <Box flexGrow={1}>
                <Typography color="textPrimary" component="div">
                  <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                    {path.name}
                  </Box>
                </Typography>
              </Box>
              {isActive && <ChevronRightIcon color="primary" />}
            </Box>
          </Link>
        );
      })} */}
      {paths.map((path) => {
        const isActive = isActiveRoute(path.link, pathname);
        return moduleAccess.includes('bccSuperAdmin') ||
          access({
            mode: 'allOf',
            scope: [path.scope],
          }) ? (
          <>
            <Link
              key={path.name}
              to={path.link}
              color="inherit"
              className={classes.textStyle}>
              <Box
                className={
                  isActive ? classes.linkStyleActive : classes.linkStyle
                }
                display="flex"
                alignItems="center">
                <Box flexGrow={1}>
                  <Typography color="textPrimary" component="div">
                    <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                      {path.name}
                    </Box>
                  </Typography>
                </Box>
                {isActive && <ChevronRightIcon color="primary" />}
              </Box>
            </Link>
          </>
        ) : null;
      })}
    </Box>
  );
};

export default SideNavBarUser;
